import { render, staticRenderFns } from "./AddTableModal.vue?vue&type=template&id=44fad382&scoped=true"
import script from "./AddTableModal.vue?vue&type=script&lang=js"
export * from "./AddTableModal.vue?vue&type=script&lang=js"
import style0 from "./AddTableModal.vue?vue&type=style&index=0&id=44fad382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fad382",
  null
  
)

export default component.exports